<div  mat-dialog-content class="window">
  <div class="list-products">
    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let product of listProducts">
      <mat-checkbox class="lp-product"  [(ngModel)]="product.selected">
        <img class="lp-p-image" [src]="imgBaseUrl +  product.PngRelativeUrlWithProduct" alt="">
        <div class="lp-p-name">{{product.Name}}</div>
      </mat-checkbox>
    </div>
  </div>
</div>
<div mat-dialog-actions style="float:right">
  <button  mat-raised-button color="primary" (click)="onClose()">Add Products</button>
</div>
